module.exports = __webpack_public_path__ + "static/media/EPUB.d0837642.svg";